export default __webpack_public_path__ + "static/media/singInPageImage.8f8f9b72.svg";